
<template>
  <div style="display:flex;flex-direction:column">
    <div class="boxbg boxbg4"  style="height:30%">
      <div class="boxTitle">AEO出口占比</div>
      <div class="boxTitle1">AEO Export Ratio</div>
      <div class="echart" style="display: flex;justify-content: center;">
      <dv-active-ring-chart :config="config" style="width:250px;height:120px" />
      </div>
      <div class="totals">AEO出口总值:{{aeoTotalEAmount}}亿</div>
      <div class="totals">Total export value of AEOs: RMB {{aeoTotalEAmount1}} billion</div>
    </div>

    <div class="boxbg boxbg5" style="min-height: 0px;flex:1;display: flex;flex-direction: column;">
      <div class="boxTitle" style="display: flex;justify-content: space-between;height: 28px;">AEO贸易伙伴（出口）</div>
      <div class="boxTitle1" style="display: flex;justify-content: space-between;">AEO Trading Partners (Export)</div>
      <div class="echart capsuleChart" style="min-height: 0px;flex:1">
        <dv-capsule-chart :config="config3" style="width:100%;height:100%" />

      </div>
    </div>
    <div class="boxbg boxbg6" style="height: 25%;margin-bottom: 0px;display: flex;flex-direction: column;">
      <div class="boxTitle">AEO贸易分布（出口）</div>
       <div class="boxTitle1">AEO trade distribution (Export)</div>
      <div class="echart" style="min-height: 0px;flex:1">
        <div id="echart261" ref="chartContainer2" style="height:100%;width: 100%;"></div>
      </div>
    </div>
  </div>

</template>

<script>
  import * as echarts from 'echarts';
	export default {
		name: "eight",
		data() {
      return {
        config:{
          radius: '60%',
          activeRadius: '65%',
          data: [],
          activeTimeGap:10000000000,
          digitalFlopStyle: {
            fontSize: 20
          }
        },
        config3:{
            data: [],
            showValue: true,
            unit: '亿元',
        },
        Chart:null,
        option:{},
        configData:[],
        timer:null,
        index:0,
        aeoTotalEAmount:'',
        aeoTotalEAmount1:'',
      }
		},
    mounted() {
      this.$Bus.$on('getIAndETradeAmount', e => {
        this.aeoTotalEAmount = e.aeoTotalEAmount;
        this.aeoTotalEAmount1 = (e.aeoTotalEAmount/10).toFixed(2);
        this.config.data = [
          {
            name: '出口',
            value: Number(e.aeoTotalEAmount),
          },
          {
            name: '总值',
            value: Number(e.totalEAmount)-Number(e.aeoTotalEAmount),
          },
         ]
         this.config = {...this.config}
      })

      this.$Bus.$on('getCountryTradeAmountProportion', e => {//AEO出口贸易分布
        let data = e.etradeAmountRankingList;
        let arr = [];
        for(let i=0;i<data.length;i++){
          let aeoTotalAmount = Math.floor(Number(data[i].aeoTotalAmount)*100)+'%'
          arr.push({ value: data[i].aeoTotalAmount, name: data[i].countryName+aeoTotalAmount })
        }
        this.datainfo(arr)
      })

      this.$Bus.$on('getCountryTradeAmountRanking', e => {
        //this.config3.unit = e.unit;
        let etradeAmountRankingList = e.data.etradeAmountRankingList;
        let seriesData = [];
        for(let i=0;i<etradeAmountRankingList.length;i++){
          seriesData.push({value:this.numbertoFixed(etradeAmountRankingList[i].aeoTotalAmount,e.unit),name:etradeAmountRankingList[i].countryName+etradeAmountRankingList[i].countryCode})
        }
        this.configData = seriesData;
       if(seriesData.length>8){//大于8才轮播
         this.setData();
       }else{
         clearInterval(this.timer);
         this.config3.data = this.configData;
         this.config3 = {...this.config3};
       }
      })
      setTimeout(()=>{this.startLegendScroll();},2000)

    },
    methods:{
      numbertoFixed(res,unit){
        let data;
        if(unit=='亿'){
          data = (Number(res) / 100000000).toFixed(2);
        }else{
          data = (Number(res) / 10000).toFixed(2);
        }
        return data;
      },
      setData(){
        clearInterval(this.timer);
        let number = 8;//一行显示的个数
        this.config3.data = this.configData.slice(0, number);
        this.config3 = {...this.config3};
        let length = Math.floor(this.configData.length/number);
        this.index = 1;
        this.timer = setInterval(()=>{
          if(this.index==0){
            this.config3.data = this.configData.slice(0, number);
            this.config3 = {...this.config3};
             this.index = this.index+1;
          }else if(length>this.index){
            this.config3.data = this.configData.slice(this.index*number, (this.index+1)*number);
            this.config3 = {...this.config3};
             this.index = this.index+1;
          }else{
            this.config3.data = this.configData.slice(this.index*number, this.configData.length);
            this.config3 = {...this.config3};
            this.index = 0;
          }
        },10000);

      },
      startLegendScroll() {
        this.$nextTick(()=>{
          const chart = echarts.getInstanceByDom(this.$refs.chartContainer2);
          if (chart) {
          	// 假设我们每秒滚动30个像素
          	setInterval(() => {
          		const currentOffset = chart.getOption().legend[0].scrollDataIndex;
          		chart.setOption({
          			legend: {
          				scrollDataIndex: currentOffset>10?0:(currentOffset + 5) // 滚动量
          			}
          		});
          	}, 10000);
          }
        })

      },
      datainfo(arr){
            //this.Chart1 = this.$echarts.init(document.getElementById('echart261'));
            const chart = echarts.init(this.$refs.chartContainer2);
            this.option1 = {
                   tooltip: {
                      trigger: 'item'
                    },
                    legend: {
                     type: 'scroll',
                      orient: 'vertical',
                      scrollDataIndex: 0,
                      right: 0,
                      top: 0,
                      bottom: 20,
                      padding:[10,0,10,0],
                      data: arr,
                     textStyle: {
                      fontSize: 18,
                       color: '#fff' // 设置文字颜色为白色
                     },
                    //  pageIconColor: '#aaa', // 翻页按钮的颜色
                    //  pageIconInactiveColor: '#2f4554', // 翻页按钮不激活时（即翻页到头时）的颜色
                    // pageFormatter:{ current: 1,total: 11 },

                    },
                    series: [
                      {
                        name: 'AEO数量',
                        type: 'pie',
                        radius: ['30%', '70%'],
                        center:['35%','50%'],
                        avoidLabelOverlap: false,
                        label: {
                          show: false,
                          position: 'right',
                          textStyle: {
                              color: '#fff' // 设置文字颜色为白色
                          }
                        },
                        data: arr
                      }
                    ]
                }
                chart.setOption(this.option1);
                //this.Chart1.setOption(this.option1);

      },
    }
	}

</script>

<style scoped>
  .boxTitle{
    width: 100%;
  }
  .capsuleChart{
    padding-right:20px;
  }
  .capsuleChart /deep/ .label-column>div{
    font-size:17px!important;
  }
  .capsuleChart /deep/ .capsule-item-value{
    font-size:17px!important;
  }
  .capsuleChart /deep/ .unit-label>div,.capsuleChart /deep/ .unit-text{
    font-size:16px!important;
  }
  .totalText{
    font-size: 20px;
    color:#1AC7FD;
    font-family: '微软雅黑';
        font-weight: 400;
  }
  .rightNumber{
    display: flex;
    align-items: center;
    font-family: '微软雅黑';
    font-weight: 400;
    justify-content: center;
  }
  .imgBox{
    width: 70px;
    height: 70px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-radius: 188px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgBox img{
    width: 42px;
    height: 42px;
  }
  .numberText{
    border-width: 0px;
    width: 280px;
    height: 100px;
    background: inherit;
    background-color: rgba(26, 201, 255, 0.298039215686275);
    border: none;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    text-align: left;
    margin-left:15px;
    padding:15px 20px;
  }
  .boxbg4{
    /* background-color: rgba(212, 49, 245, 0.3); */
    background-color: rgba(98, 192, 220, 0.3);
  }
  .boxbg5{
    /* background-color: rgba(5, 224, 53, 0.308); */
    background-color: rgba(239, 150, 68, 0.3);
  }
  .boxbg6{
    /* background-color: rgba(16, 111, 235, 0.644); */
    background-color: rgba(183, 218, 198, 0.3);
  }
</style>



// WEBPACK FOOTER //
// src/components/leftNew/leftTwo.vue